import React, { useEffect } from "react";

import { Container } from "../components";
import { useQueryString } from "../hooks";

export default function ChecksPage() {
  const queryString = useQueryString();
  const service = queryString?.service;

  useEffect(() => {
    if (service === "sentry") {
      throw new Error("test sentry error partners-web");
    }
  }, [service]);

  return <Container></Container>;
}
